/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Event/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Appointment from './Appointment/index'
import No from './No/index'
import Note from './Note/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Event({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventTypeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Appointment'}>
<Appointment
  viewPath={`${viewPath}/Appointment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Note'}>
<Note
  viewPath={`${viewPath}/Note`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}